<template>
  <div>
    <div class="gl_title_bar EC_width"
         v-show="kechengList.length>0"
         style="margin-bottom:20px">
      <div class="gl_tb_left">
        <span class="tagTitle tagTitleActive">
          {{ newlabelName }}
        </span>
      </div>
    </div>
    <div class="t3mid  EC_width">
      <div class="t3mbox"
           v-for="(item,index) in kechengList"
           :style="(index+1)%4==0?'margin-right:0':''"
           @click="tokecheng(item.id)"
           :key="index">
        <img :src="item.acr_PictResUrl"
             alt="">
        <div class="t3mboxbot">
          <span class="t3title">{{item.title}}</span>
          <div class="t3biaoqian">
            <div v-for="(items,index) in item.labelName.split(',')"
                 :key="index+'s'"
                 :style="index==0?'margin-left:0':''"
                 v-show="items!=''">
              <span>{{items}}</span>
            </div>
          </div>
          <div class="t3more">
            <div>
              <span style="color:red"
                    v-show="item.discountStatus == 2">免费</span>
              <span v-show="item.discountStatus == 1">VIP专享</span>
              <span v-show="item.discountStatus == 3">{{item.price}}</span>
            </div>
            <div>
              <img src="../../assets/img/icon/ren.png"
                   style="width:10px;height:11px;margin-right:10px"
                   alt="">
              <span>{{item.playSum}}人</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    labelName: {
      type: String,
      default: ''
    },
    newlabelName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      kechengList: []
    };
  },
  created () {
    this.getlist()
  },
  methods: {
    getlist () {
      this.httphelper
        .post('/api/NewApi/GetDbRecommendHomeCoursePageList', {
          labelName: this.labelName,
          number: 4,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.kechengList = res.data.data
          }
        });
    },
    tokecheng (id) {
      window.open(this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id, "_blank")
    }
  },
};
</script>
<style>
.t3mid {
    display: flex;
    flex-wrap: wrap;
}
.t3mbox {
    height: 288px;
    width: 280px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-right: 40px;
    margin-bottom: 30px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 5px 5px;
    cursor: pointer;
}
.t3mbox img {
    height: 158px;
    width: 280px;
}
.t3mboxbot {
    padding: 15px 15px 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
}
.t3title {
    width: 100%;
    height: 38px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.t3more {
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #919ca3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t3biaoqian {
    display: flex;
    flex-wrap: wrap;
}
.t3biaoqian div {
    background: #ffffff;
    border: 1px solid #979fa6;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #979fa6;
    padding: 0px 3px;
    /* margin-left: 3px; */
    margin-right: 3px;
    margin-top: 1px;
    margin-bottom: 1px;
}
.t3biaoqian span {
    white-space: nowrap;
}
</style>